export interface IJoinJobData {
  title?: string;
  specialization?: string;
  skill?: string;
  jobPostingUrl?: string;
  utmSource?: string;
  utmProvider?: string;
}

export const decodeJoinJobData = (data: string): IJoinJobData | null => {
  try {
    return JSON.parse(window.atob(data));
  } catch {
    return null;
  }
};
